export default "__VITE_ASSET__GA9ySjDF__"